<!-- AlertsPanel toggle -->
<button mat-icon-button (click)="openPanel()" #alertsPanelOrigin>
    @if (notificacionesService.unreadCount() > 0) {
    <span class="absolute left-0 right-0 top-0 flex h-3 items-center justify-center">
        <span
            class="ml-4 mt-2.5 flex h-4 min-w-4 shrink-0 items-center justify-center rounded-full bg-teal-600 px-1 text-xs font-medium text-indigo-50">
            {{ notificacionesService.unreadCount() }}
        </span>
    </span>
    }
    <mat-icon class="text-white" [svgIcon]="'heroicons_outline:bell'"></mat-icon>
</button>

<!-- AlertsPanel panel -->
<ng-template #alertsPanelPanel>
    <div
        class="fixed inset-0 flex flex-col overflow-hidden shadow-lg sm:static sm:inset-auto sm:w-90 sm:min-w-90 sm:rounded-2xl">
        <!-- Header -->
        <div class="flex shrink-0 items-center bg-primario-50  py-4 pl-6 pr-4 text-on-primary">
            <div class="-ml-1 mr-3 sm:hidden">
                <button mat-icon-button (click)="closePanel()">
                    <mat-icon class="text-current icon-size-5" [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
                </button>
            </div>
            <div class="text-lg font-medium leading-10">Notificaciones</div>
            <div class="ml-auto">
                <button class="dark:text-white" mat-icon-button [matTooltip]="'Marcar todas como leídas'"
                    [disabled]="notificacionesService.unreadCount() === 0" (click)="markAllAsRead()">
                    <mat-icon class="text-current icon-size-5" [svgIcon]="'heroicons_solid:envelope-open'"></mat-icon>
                </button>
            </div>
        </div>

        <!-- Content -->
        <div class="bg-card relative flex flex-auto flex-col divide-y overflow-y-auto sm:max-h-120">
            <!-- AlertsPanel -->
            @for (
            notification of notificacionesService.notificaciones();
            track trackByFn($index, notification)
            ) {
            <div class="group flex hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5"
                [ngClass]="{ unread: !notificacionesService.leidas().has(notification.id) }">
                <!-- Always link to notificaciones details -->
                <a class="flex flex-auto cursor-pointer py-5 pl-6" [routerLink]="['/notificaciones', notification.id]"
                    (click)="onNotificationClick(notification.id)">
                    <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                </a>
            </div>

            <!-- Notification content template -->
            <ng-template #notificationContent>
                <div class="flex flex-auto flex-col items-start pr-6">
                    <div class="mb-1 flex w-full items-center justify-between">
                        <span class="text-md leading-none font-semibold truncate">{{ notification.title }}</span>
                    </div>
                    <div class="line-clamp-2 text-sm text-secondary">
                        {{ notification.body }}
                    </div>
                    <!-- Date -->
                    <div class="mt-2 text-sm text-secondary">
                        {{ notification.createdAt | date: 'dd/MM/yyyy HH:mm' }}
                    </div>
                </div>
            </ng-template>
            } @empty {
            <div class="flex flex-auto flex-col items-center justify-center py-12 px-8 sm:px-16">
                <div
                    class="flex h-14 w-14 flex-0 items-center justify-center rounded-full bg-primary-100 text-primary-500 dark:bg-primary-600 dark:text-primary-50">
                    <mat-icon class="text-current" [svgIcon]="'heroicons_outline:bell'"></mat-icon>
                </div>
                <div class="mt-5 text-center text-2xl font-semibold tracking-tight">
                    No hay notificaciones
                </div>
                <div class="mt-1 w-full max-w-60 text-center text-md text-secondary">
                    Cuando tengas notificaciones nuevas aparecerán aquí.
                </div>
            </div>
            }
        </div>
    </div>
</ng-template>